var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-retelling',_vm._b({attrs:{"title":"Monologue"}},'app-retelling',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }